var collapsible_list_component_rtlignore_default = {
  "ltr": "_4Try6",
  "rtl": "hsIAU",
  "iconContainer": "r-iIb",
  "icon": "xM9p-",
  "isExpanded": "FE816",
  "listDimensions": "MA7-8"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
